'use client';

import type { FC, ReactNode, MouseEventHandler } from 'react';

import type { Language } from '@packages/config/src/default/types';

import { Link } from '../../../../Link/Link';

export type SlotEquivalentLinksItemProps = {
  ariaLabel?: string;
  children: ReactNode;
  href: string;
  language?: Language;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  isBusy?: boolean;
};

export const SlotEquivalentLinksItem: FC<SlotEquivalentLinksItemProps> = ({
  ariaLabel,
  href,
  language,
  children,
  onClick,
  isBusy = false,
}) => (
  <li className="border-color-grey border-b">
    <Link
      className={`flex items-center ${isBusy ? 'pointer-events-none touch-none opacity-50' : ''} gap-3 px-2 py-1`}
      href={href}
      language={language}
      onClick={isBusy ? undefined : onClick}
      aria-label={ariaLabel}
      aria-busy={isBusy ? 'true' : undefined}
      aria-disabled={isBusy ? 'true' : undefined}
    >
      {children}
    </Link>
  </li>
);
